import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SocialButton from './SocialButton';

const PrimarySocials = ({socials, className, type = 'default'}) => (
  <div className={classNames('primary-socials', `primary-socials--${type}`, className)}>
    <ul className="social-list">
      {socials.map((item, index) => (
        <li key={index}>
          <SocialButton role="primary" name={item.name} label={item.name} url={item.url} />
        </li>
      ))}
    </ul>
  </div>
);

PrimarySocials.propTypes = {
  socials: PropTypes.array.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['default', 'registration'])
};

export default PrimarySocials;



// WEBPACK FOOTER //
// ./components/PrimarySocials.jsx